import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon, SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  error(message: string, icon: SweetAlertIcon = 'error') {
    return Swal.fire({
      html: message,
      icon,
      confirmButtonColor: '#ce343c',
      customClass: { icon: 'swal-icon-sm' }
    })
  }

  confirm(message: string, title?: string) {
    return Swal.fire({
      title: title,
      html: message,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#ce343c',
      customClass: { icon: 'swal-icon-sm' }
    })
  }

  showLoading(message?: string) {
    Swal.fire({
      html: message,
      allowOutsideClick: false,
      didOpen() {
        Swal.showLoading()
      }
    })
  }

  success(message?: string, options?: SweetAlertOptions) {
    return Swal.fire({
      html: message,
      icon: 'success',
      confirmButtonColor: '#ce343c',
      customClass: { icon: 'swal-icon-sm' },
      didOpen() {
        Swal.hideLoading()
      },
      ...options
    })
  }

  dismiss() {
    Swal.close()
  }
}
